import { jsx as _jsx } from "react/jsx-runtime";

function SvgClaim() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.777 3c0-1.471 1.127-3 3-3h10.171a3 3 0 012.122.879l3.828 3.828a3 3 0 01.879 2.121V21c0 .827-.271 1.6-.844 2.166-.571.566-1.348.834-2.183.834H4.777c-.836 0-1.61-.269-2.177-.84-.565-.571-.823-1.343-.823-2.16V3zm3-1c-.613 0-1 .471-1 1v18c0 .398.12.626.244.752.123.124.349.248.756.248H18.75c.408 0 .644-.125.776-.255.13-.13.25-.357.25-.745V8h-4a2 2 0 01-2-2V2h-9zm11 .414L19.363 6h-3.586V2.414zM12.402 15.51c.127.146.19.348.19.605 0 .231-.063.414-.19.547-.127.13-.301.195-.523.195-.302 0-.537-.096-.703-.288-.162-.195-.244-.478-.244-.85H9.287c0 .675.188 1.218.566 1.632.38.41.926.652 1.636.727v.986h.776v-.981c.609-.059 1.089-.264 1.44-.615.355-.352.533-.806.533-1.363 0-.328-.056-.61-.166-.844a1.93 1.93 0 00-.46-.615 3.189 3.189 0 00-.697-.47 10.99 10.99 0 00-.855-.4c-.303-.13-.522-.265-.66-.405-.136-.143-.204-.335-.204-.576 0-.238.058-.423.176-.557.12-.136.288-.205.502-.205.241 0 .427.091.557.274.13.182.196.442.196.78h1.65c0-.618-.171-1.127-.513-1.527-.338-.404-.805-.65-1.401-.738v-1.05h-.777v1.03c-.618.06-1.113.268-1.484.626-.371.355-.557.807-.557 1.357 0 .329.052.609.157.84.104.231.254.435.449.61.195.176.428.33.698.464.27.134.565.265.884.396.319.13.542.268.669.415z"
    }, void 0)
  }), void 0);
}

export default SvgClaim;